import { render, staticRenderFns } from "./Mainpage.vue?vue&type=template&id=9469e60c&"
import script from "./Mainpage.vue?vue&type=script&lang=js&"
export * from "./Mainpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports